module.exports = __webpack_public_path__ + "static/media/ArtWorks group pic_3.4c3c12ad.jpg";